import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";

function HospitalDoctor() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
const [ccid, setCcid] = useState(null);

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  // 🔹 Delete Mapping
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody({ id: selectedId }, secretKey);

      const response = await axios.post("/api/patientdoctormapping/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        toast.success(decryptedResponse.message || "Patient Doctor Mapping deleted successfully!");
        setDeleteModal(false);
        fetchMapping();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete mapping.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch All Mappings
  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/hospitalprofile/doctors/${userid}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
        if (decryptedData.content && decryptedData.content.length > 0) {
  const ccidValue = decryptedData.content[0].ccid;
  setCcid(ccidValue); // new state
  console.log("Stored CCID:", ccidValue);
}
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMapping();
  }, []);
 const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchMapping(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  const doctorInfo = mappingList.length > 0 ? mappingList[0].doctor : null;
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
   
 const requestBody = encryptBody(
      { ccid: ccid, searchTerm: searchTerm },
      secretKey
    );
   
      const response = await axios.post(`/api/hospitalprofile/search`, requestBody, {
                params: { page: Math.max(0, pageNumber - 1) },  

       
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching Care Coordinator:", error);
    } finally {
      setLoading(false);
    }
  };
  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];
  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
 <MDBox mt={1} p={1} display="flex"  alignItems="center">
  

   <MDTypography variant="h5" sx={{ flex: 1 }}>
   Doctors Associated with this Hospital
  </MDTypography>

  <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <MDInput
            label="Search  Name "
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: "400px" }}
          />
        </MDBox>
        <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>


          {/* <MDButton
            variant="gradient"
            onClick={() => navigate("/CreateDPmapping")}
            sx={{
              background: "#2e7faeff",
              color: "#fff",
              "&:hover": {
                background: "#2e7faeff",
              },
            }}
          >
            Create Mapping
          </MDButton> */}
       
    </MDBox>
   

      </MDBox>
     

      {/* Table */}
     {/* Doctor Info Section */}
{doctorInfo && (
  <MDBox sx={{ mt: 1, ml: 2 }}>   {/* moved slightly right with margin-left */}
    {/* <MDTypography 
      variant="body2"  // smaller font
      sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
    >
      Hospital Name:{" "}
      <span style={{ fontWeight: "normal", color: "#555" }}>
        {doctorInfo.firstname} {doctorInfo.lastname}
      </span>
    </MDTypography> */}

    {/* <MDTypography 
      variant="body2"  // smaller font
      sx={{ fontWeight: 600, color: "#333" }}
    >
      Hospital Address:{" "}
      <span style={{ fontWeight: "normal", color: "#555" }}>
        {doctorInfo.doctorType}
      </span>
    </MDTypography> */}
  </MDBox>
)}
      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
         <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
         
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1A237E" }}>
          {[ " Doctor Name", "Email" ,"Doctor Type" ," Contact"," NMC Number","Address"].map((header, index) => (
                  <TableCell
                    key={index}
                   sx={{
                   color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
  minWidth: index === 0 ? "150px" : "150px",
width: index === 0 ? "315px" : "195px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>

            <TableBody>
              {mappingList.length > 0 ? (
                mappingList.map((mapping, index) => (
                  <TableRow key={index}>
                  
                <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
  }}
  onClick={() => navigate(`/PatientViewDetails/${mapping?.patient?.id}`)}
>
  {mapping.firstname} {mapping.lastname}
</TableCell>


                
                     <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.email}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.doctorType}
                    </TableCell>
                     <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.phoneNumber}
                    </TableCell> <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.nmcRegisteredNumber}
                    </TableCell>
                   <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",
  }}
>
  {`${mapping.address}, ${mapping.state}, ${mapping.city}, ${mapping.pin}, ${mapping.country}`}
</TableCell>
                    {/* <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                     
                      <IconButton color="default" onClick={() => handleOpenDeleteModal(mapping.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}
                  >
                    No Data Available.
                  </TableCell>
                </TableRow>
              )}
              
            </TableBody>
                        </TableHead>

            <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#2e7faeff",          // Text color
                  borderColor: "#2e7faeff",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#2e7faeff", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#2e7faeff33", // Slight hover effect
                },
              }}
                      />
                    </Box>
          </Table>
        </TableContainer>
      </MDBox>

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this mapping?
          </MDTypography>
          <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background: "#2e7faeff", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default HospitalDoctor;
